/* eslint-disable react/display-name */
import React, { useState, useEffect } from 'react'
import './ToolkitComponent.scss'
import Layout from '../../../layouts/Layout'
import { Header, Form, Checkbox, Grid, Image } from 'semantic-ui-react'
import {
  countryData,
  nameToId
  } from '../mapData'
import ReactTooltip from 'react-tooltip'
import Map from './Map.js'
import Chart from './Chart'
import _ from 'lodash'
import ToolkitCountry from './ToolkitCountry'
import CustomDropdown from '../../CustomDropdown/CustomDropdown'
import ToolkitType from './ToolkitType'
import Arrow from '../../../addons/images/arrow.png'

const toolkitComponent = ({ params, getChart }) => {
  const [type, setType] = useState(0)
  const [content, setContent] = useState('')
  const [isUseToolkitActive, changeUseToolkitActive] = useState(false)
  const [isAboutToolkitActive, changeAboutToolkitActive] = useState(false)

  return (
    params.chartType
      ? <ToolkitType params={params} getChart={getChart}/> : params.id
      ? <ToolkitCountry params={params} getChart={getChart}/> : <Layout link={['Toolkit']}>
        <Header as='h1'>Polarisation indicators</Header>
        <Header as='h2'>
          Set of indicators that can be applied in specific policy areas
        </Header>
        <Grid>
          <Grid.Column mobile={16} tablet={13} computer={13}>
            <Map setTooltipContent={setContent} type={type} />
            <ReactTooltip backgroundColor='white'>
              {content && _.find(countryData[type], { name: content }) &&
              <React.Fragment>
                <Header as='h5'>{`POL. SCORE/RES. SCORE: ` +
              `${_.find(countryData[type], { name: content }).polarisation} /
              ${_.find(countryData[type], { name: content }).resilience}` } </Header>
                <Chart data={[_.find(countryData[type], { name: content })]} width={350} height={200} />
              </React.Fragment>}
            </ReactTooltip>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={3} computer={3}>
            <Header as='h3'>Types of Polarisation and Resilience</Header>
            <Form>
              <Form.Field>
                <Checkbox
                radio
                label='Ethnic/Racial'
                name='checkboxRadioGroup'
                style={{ fontSize: '1rem' }}
                checked={type === 0}
                onChange={() => setType(0)}
              />
              </Form.Field>
              <Form.Field>
                <Checkbox
                radio
                label='Religious'
                name='checkboxRadioGroup'
                style={{ fontSize: '1rem' }}
                checked={type === 1}
                onChange={() => setType(1)}
              />
              </Form.Field>
              <Form.Field>
                <Checkbox
                radio
                label='Political'
                style={{ fontSize: '1rem' }}
                name='checkboxRadioGroup'
                checked={type === 2}
                onChange={() => setType(2)}
              />
              </Form.Field>
              <Form.Field>
                <Checkbox
                radio
                label='Gender/Sex/Orientation'
                style={{ fontSize: '1rem' }}
                name='checkboxRadioGroup'
                checked={type === 3}
                onChange={() => setType(3)}
              />
              </Form.Field>
              <Form.Field>
                <Checkbox
                radio
                label='Socio-Economic'
                style={{ fontSize: '1rem' }}
                name='checkboxRadioGroup'
                style={{ color: '#4AB596' }}
                checked={type === 4}
                onChange={() => setType(4)}
              />
              </Form.Field>
            </Form>
          </Grid.Column>
        </Grid>
        <Grid style={{ marginBottom: 20, marginTop: '-5px' }}>
          <Grid.Column mobile={16} tablet={13} computer={13}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
            <div style={{ width: '40%' }}>
              <Image src={Arrow} style={{ width: '100%' }}/>
              <Header as='h5' style={{ color: '#4472C4', margin: 0, float: 'right' }}>ABOVE EU AVERAGE</Header>
            </div>
            <div style={{ width: '40%' }}>
              <Image src={Arrow} style={{ width: '100%', transform: 'rotate(180deg)' }}/>
              <Header as='h5' style={{ color: '#4472C4', margin: 0 }}>BELOW EU AVERAGE</Header>
            </div>
          </Grid.Column>
        </Grid>
        <CustomDropdown
          title='About this Toolkit'
          active={isAboutToolkitActive}
          changeActive={changeAboutToolkitActive}
        >
          <p>
            The BRaVE toolkit allows one to gain a view of ethnic/racial, religious, socio-economic, political,
            and gender, sex and sexuality based polarisation and resilience across ten EU countries: Belgium,
            Denmark, France, Germany, Greece, Hungary, Italy, the Netherlands, Poland, and the UK. We are aware
            that there are many interpretations of the terms ‘polarisation’ and ‘resilience’ and that these
            terms can be controversial and divisive.
          </p>
          <p>
            To be clear, when we refer to ‘polarisation’, we refer to the damaging of relationships between
            individuals and the state and/or individuals and their community. When we refer to ‘resilience’,
            we refer to the building of relationships between individuals and the state, and/or individuals
            and their community. This conception is drawn from the work of Ellis and Abdi (2017), and our
            approach to polarisation is an extension of this work.
          </p>
          <p>
            To this end, the toolkit consists of two sets of indicators: indicators of polarisation and
            indicators of resilience. Polarisation indicators are mirrored by a set of corresponding
            Moderation indicators, for example, the polarising indicator set ‘Lack of Belonging’, which
            contains measures of individuals’ low/no sense of attachment to their local community and
            country, is mirrored by the moderating indicator set Sense of Belonging, which contains
            measures of individuals’ heightened sense of attachment to their country or community.
            Likewise, Resilience indicators are mirrored by a set of corresponding non-resilience indicators.
          </p>
          <p>
            The toolkit is designed for a wide range of users: researchers, policy makers, NGOs, and so
            on. For this reason, the indicators are general in nature. Essentially, the toolkit is aimed
            at anyone who is interested in gaining an overview of the current state of different types of
            polarisation and resilience across the EU, whether this be policy makers looking at areas
            that could be targeted for future policy initiatives, NGOs who wish to persuade politicians
            that there is a case for tackling a particular issue within their country, or researchers
            seeking to understand the similarities and differences between EU countries on different
            forms of polarisation and/or resilience.
          </p>
          <p>
            Please note that the general nature of the indicators therefore makes them not as informative
            for discussing polarisation and/or resilience within a very specific context, for example,
            the education system or the prison service, and that most indicators are national in scope,
            meaning that they may not be applicable at a local or regional level. Nevertheless, the
            indicators may still assist in situating one’s context specific or local/regional data
            within a national or broader EU context.
          </p>
          <p>
            Crucially, scores are not meant as an indication of country X performing better or worse than
            country Y in terms of polarisation or resilience. Rather, they are intended to recognise
            individuals’ fears around those they consider to be different from themselves. Recognising
            and understanding the nature of these fears is the first step towards opening up a
            conversation on such issues and building connections between individuals and the state
            and/or their communities. For example, if a country scores above the EU average on
            non-resilience indicators of Undemocratic Reporting and below the EU average on resilience
            indicators of Democratic Reporting, then perhaps what is needed is an understanding of
            current media practices and a discussion with relevant parties on ways of reporting that
            might strengthen connections between individuals and state owned media.
          </p>
          <p>
            For details on the underlying measures and how they were constructed, please see the
            project’s <a href='/repository/BRaVE Summary Report on Deliverable 4.3.pdf' target='_blank'>
              Toolkit report</a>.
          </p>
        </CustomDropdown>
        <CustomDropdown
          title='How to use this Toolkit'
          active={isUseToolkitActive}
          changeActive={changeUseToolkitActive}
        >
          <ol>
            <li>
              To begin, select a type of polarisation and resilience that you are interested in looking at.
              These include: Ethnic/Racial, Religious, Gender, Sex and Sexuality, Socio-Economic and Political.
            </li>
            <li>
              Hover over a country of interest on the map (we currently hold data for the following countries:
              Belgium, Denmark, France, Germany, Greece, Hungary, Italy, Netherlands, Poland, and the UK).
              You will see a chart appear, which compares your selected country’s average polarisation and
              resilience scores across our various indicators.
            </li>
            <li>
              To see your selected country’s polarisation and resilience scores in the context of other EU
              countries, click on the country on the map. You will be taken a chart comparing average
              polarisation and resilience scores for all EU countries that we currently hold data on.
            </li>
            <li>
              Next to this chart, you should see two possible selections: Polarisation Detail and Resilience
              Detail. To see a breakdown of your selected country’s scores on different sets of polarisation
              indicators, select ‘Polarisation Detail’. For a similar breakdown of countries’ scores on
              resilience indicators, select ‘Resilience Detail’.
            </li>
            <li>
              Once you have made your selection, you will see a series of charts, which compare your selected
              country’s scores on different sets of indicators with the scores of other countries within the
              EU. To find out what types of measures are used to determine these scores (and the sources from
              which measures are drawn), read the descriptions included underneath the charts.
            </li>
            <li>
              If you would like a more detailed view of how a country scores on individual measures within an
              indicator set (for example, if you would like to see a country’s scores on specific measures of
              Social Inclusion), click the ‘Download full list of measures’ button at the bottom of the page.
            </li>
            <li>
              If you would like to download individual charts for use in presentations, click the ‘Download chart’
              button underneath the relevant chart. Alternatively, to download all charts and their summary
              descriptions and sources, click the ‘Download all charts’ button at the bottom of the page.
            </li>
          </ol>
        </CustomDropdown>
      </Layout>
  )
}
toolkitComponent.propTypes = {
}
export default toolkitComponent



// WEBPACK FOOTER //
// ./src/components/ToolkitComponent/components/ToolkitComponent.js